module.exports = __webpack_public_path__ + "Flag-233.d1daa63e8fb5351041e762e696ad33da.svg";